// primary roles allowed to see categories marked adminOnly
export const ADMIN_ROLES = ["Admin", "ROLE_ADMIN", "ROLE_EKAL_ADMIN"];

// Settings configuration
export const settingsData = [
  {
    key: "schoolSetting",
    label: "School Settings",
    children: [
      // school setting
      {
        key: "school",
        label: "School",
        link: "/settings/schoolSetting/school",
        description: "Manage school profile and basic information",
      },
      {
        key: "general",
        label: "General Settings",
        link: "/settings/schoolSetting/general",
        description: "Manage general school settings",
      },
      {
        key: "serialNumber",
        label: "Serial Number Settings",
        link: "/settings/schoolSetting/serialNumber",
        description: "Manage serial number settings",
      },
    ],
  },
  {
    key: "studentSetting",
    label: "Student Settings",
    children: [
      // student setting
      {
        key: "requiredDocument",
        label: "Required Documents",
        link: "/settings/studentSetting/requiredDocument",
        description: "Manage student required document settings ",
      },
      {
        key: "parentDecleration",
        label: "Parent Declaration",
        link: "/settings/studentSetting/parentDecleration",
        description:
          "Manage parent declaration settings for Admission form print",
      },
    ],
  },
  {
    key: "communicationSetting",
    label: "Communication Settings",
    children: [
      // communication setting
      {
        key: "whatsapp",
        label: "WhatsApp Settings",
        link: "/settings/communicationSetting/whatsapp",
        description: "Manage WhatsApp communication settings",
      },
    ],
  },
  {
    key: "thirdPartyIntegration",
    label: "Third Party Integration",
    adminOnly: true,
    children: [
      // third party integration
      {
        key: "whatsappProvider",
        label: "WhatsApp Provider",
        link: "/settings/thirdPartyIntegration/whatsappProvider",
        description: "Choose the WhatsApp service provider",
      },
    ],
  },
];
